import { Student } from '../../../types/Student';

const WallOfFameCard = (student: Student) => {
  const { avatar_url, user_login, topic, topic_count, wall_of_fame } = student;
  return (
    <div className='p-2.5 h-full'>
      <div className='bg-[#FFEBAA] h-full rounded-xl p-2 border border-[#C3980C]'>
        <div className='relative'>
          <img src={avatar_url} alt={user_login} width={279} height={203} className='rounded-lg w-full max-h-[12.6875rem] object-cover' />
          {/* <div className='absolute bottom-0 right-0'>
            <div className='flex items-center p-2 rounded-tl-lg bg-white gap-0.5 text-sm text-black font-semibold'>
              <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.33301 5.91805C2.33301 3.2948 4.42251 1.16797 6.99967 1.16797C9.57684 1.16797 11.6663 3.2948 11.6663 5.91805C11.6663 8.52088 10.1771 11.5589 7.85309 12.6445C7.58597 12.7695 7.29463 12.8344 6.99967 12.8344C6.70472 12.8344 6.41338 12.7695 6.14626 12.6445C3.82226 11.5583 2.33301 8.52089 2.33301 5.91864V5.91805Z'
                  stroke='black'
                />
                <path d='M7 7.58594C7.9665 7.58594 8.75 6.80244 8.75 5.83594C8.75 4.86944 7.9665 4.08594 7 4.08594C6.0335 4.08594 5.25 4.86944 5.25 5.83594C5.25 6.80244 6.0335 7.58594 7 7.58594Z' stroke='black' />
              </svg>
              {location}
            </div>
          </div> */}
        </div>
        <div className='px-4 py-2'>
          <h2 className='font-bold text-2xl pt-2 text-black capitalize text-center'>{user_login}</h2>
          <div className='flex items-center justify-center'>
            <div className='flex flex-row gap-1 justify-center items-center'>
              <img src='./star.svg' alt='mastery icon' className='w-4 h-4' />
              <p className='text-gray-600 text-sm line-clamp-2 text-center pt-1'>{wall_of_fame == 'true' ? `DT: ${topic}` : `${topic_count} Topics Mastered`}</p>
              <img src='./star.svg' alt='mastery icon' className='w-4 h-4' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WallOfFameCard;
